import React from 'react';
export function About() {
  return <section className="w-full bg-plum px-4 py-14 text-white" data-id="element-18" data-mp="flqtogv8rq18">
      <div className="mx-auto max-w-2xl text-center" data-id="element-19" data-mp="2pqp2jrovidle">
        <h2 className="font-display text-2xl font-black sm:text-3xl" data-id="element-20" data-mp="2ptbiofpty1f8">
          🧶 Sobre Karito Educa
        </h2>
        <div className="mt-6 space-y-4 text-sm leading-relaxed text-white/85" data-id="element-21" data-mp="2ys58nn8nntjt">
          <p data-id="element-22" data-mp="2yq2ecr0gze9a">
            Karito Educa nació después de vivir la misma frustración que tienen
            miles de tejedoras. Tener tiempo para tejer… tener lana, tener
            agujas, tener ganas. Y aun así quedarse paralizada pensando:{' '}
            <em className="font-semibold text-mauve-soft" data-id="element-23" data-mp="3dgt6k05z4fcx">”¿Qué hago hoy?”</em>
          </p>
          <p data-id="element-24" data-mp="3hiwh8mktjfx5">
            Con el tiempo descubrimos algo muy importante. El problema nunca era
            la falta de creatividad. Ni de experiencia. Ni de patrones.{' '}
            <strong className="text-white" data-id="element-25" data-mp="3rgu538yrnap8">
              El verdadero problema era no tener un sistema para decidir.
            </strong>
          </p>
          <p data-id="element-26" data-mp="2ls0imomkrxc4">
            Así nació <strong className="text-white" data-id="element-27" data-mp="2lp4iqur62yl1">¿Qué Tejo Hoy?™</strong>. Un
            método creado para ayudarte a pasar menos tiempo buscando… y mucho
            más tiempo disfrutando cada puntada.
          </p>
          <p className="font-display text-base font-semibold italic text-mauve-soft" data-id="element-28" data-mp="2csdn2jgj1lqz">
            Porque creemos que el tejido debería darte tranquilidad. No más
            frustración.
          </p>
        </div>
      </div>
    </section>;
}